import { Dataset } from "@mui/icons-material";
import DiscountIcon from "@mui/icons-material/Discount";
import StorefrontIcon from "@mui/icons-material/Storefront";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SummarizeIcon from "@mui/icons-material/Summarize";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PaymentsIcon from '@mui/icons-material/Payments';

export const eboPaymentDashboardServices = {
    cofo: {
        name: "COFO",
        key: "cofo",
        display: true,
        icon: <DiscountIcon />,
        types: {
            cofo_reports: {
                name: "COFO Report",
                key: "cofo_reports",
                display: true,
                icon: <StoreMallDirectoryIcon />,
            },
            mapping_stores: {
                name: "Map Stores",
                key: "mapping_stores",
                display: true,
                icon: <WhereToVoteIcon />,
            },
            cofo_commission_master: {
                name: "Commission Master",
                key: "cofo_commission_master",
                display: true,
                icon: <RequestQuoteIcon />,
            },
            salary_petty_cash_master: {
                name: "Salary/Petty Cash",
                key: "salary_petty_cash_master",
                display: true,
                icon: <PaymentsIcon />,
            },
        },
    },
    fofo: {
        name: "FOFO",
        key: "fofo",
        display: true,
        icon: <Dataset />,
        types: {
            fofo_reports: {
                name: "FOFO Report",
                key: "fofo_reports",
                display: true,
                icon: <StorefrontIcon />,
            },
            fofo_commission_master: {
                name: "Commission Master",
                key: "fofo_commission_master",
                display: true,
                icon: <AccountBalanceWalletIcon />,
            },
            fofo_cash_card_collection: {
                name: "Cash/Card Collection",
                key: "fofo_cash_card_collection",
                display: true,
                icon: <CreditCardIcon />,
            },
        },
    },
};
